
import {Dispatch} from "react";

import * as Constants from "../constants";

/* Redux */
import {useDispatch} from "react-redux";
import {setLoginPromptModalActive} from "../redux/slices/login-modal-slice";
import {addToast} from "../redux/slices/toast-slice";
import {AnyAction} from "@reduxjs/toolkit";
import {setLoggedIn} from "../redux/slices/user-slice";

const useError = (): {handleError: Function} => {
  const dispatch:Dispatch<AnyAction> = useDispatch();

  const handleError = (e:any): void => {
    e = JSON.parse(JSON.stringify(e)); // status is not parsed correctly in raw error
    if ((e.status === 403) || (e.status === 401)) {
      dispatch(setLoggedIn(false))
      dispatch(setLoginPromptModalActive(true));
    } else {
      dispatch(addToast({
        bg: 'bg-danger',
        msg: Constants.ERROR_NOTIFICATION,
        id: -1
      }))
    }
  }

  return {
    handleError
  }
};

export default useError;
